import { of, from } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ofType, combineEpics } from "redux-observable";
import { matchPath } from "react-router";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { loadAutoShutDownTypes, loadingAutoShutDown, loadedAutoShutDown, loadSrmMoorTypes, loadingSrmMoor, loadedSrmMoor, loadSrmAlertTypes, loadingSrmAlert, loadedSrmAlert, loadStudiesForStepActionPrefix, reduxNestedKeys, loadScorecardForStudies, loadScorecardsForStudiesTypes, loadedScorecardForStudies, loadingScorecardForStudies, loadToCheckEmptyScPrefix, resolveQualityAlertsPrefix, loadSrmMoor, loadedSrmAsyncAlert, loadScorecardDataTypes, loadedScorecardData, loadingScorecardData, loadMetricCategoriesPrefix, loadExperimentPlanIdTypes, loadingExperimentPlanId, loadExperimentInfo, loadHypothesisActionPrefix, loadExperimentInfoTypes, loadingExperimentInfo, loadedExperimentInfo, loadPlanSummaryActionPrefix, loadScorecardInsightsPrefix, setUserContext } from "../ducks/GarDucksTypes.js";
import GarXCardResource from "../resources/GarxCard.resource.js";
import GarScorecardResource from "../resources/GarScorecard.resource.js";
import GarExpApiResource from "../resources/GarExpApi.resource.js";
import AlertingResource from "@ane/exp-data/lib/resources/Alerting.resource";
import SRMCheckResource from "@ane/exp-data/lib/resources/SRMCheck.resource";
import { AnalysisState, AnalysisType } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import GarVivaceResource from "../resources/GarVivace.resource.js";
import { filterSRMEvidences, getUserDefinedFilters, getMarketsFilterValues, getScorecards, getUniqueMetricSets, getMappedMetrics, getFilteredMetricCategories } from "../utils/ReducerUtils.js";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { GARContextParams } from "../utils/GarContext.js";
import GarConstants from "../models/GarConstants.js";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import ___default from "lodash";
import { checkAutoShutdownLoad, mainFunctionality, checkAlertsLoad, checkWarningsLoad, checkStepPropertiesLoad, checkPlanSummaryLoad, checkAnalysesLoad, checkScorecardsLoad, checkHypothesisLoad, checkSlicesLoad, checkMetricCategoriesLoad, checkScorecardDataLoad, checkExperimentInfoLoad, checkScorecardInsightsLoad } from "../actions/GarLogPerformanceActions.js";
import GarLogPerformanceConstants from "../actions/GarLogPerformanceConstants.js";
import { XCARD_DOMAIN } from "@ane/exp-data/lib/constants/LinkConstants";
import { matchesRootPathname } from "@ane/exp-data/lib/routes/Route.utils";
import { GarRouteUtils } from "@ane/exp-data/lib/routes/GuidedAnalysisResultsRoute.utils";
const loadAutoShutDownArgs = {
  filterOnType: loadAutoShutDownTypes.LOAD,
  loadResource: (payload, state) => {
    return AlertingResource.loadAutoShutdown(payload.workspaceid, payload.stepId);
  },
  loadingAction: (payload) => loadingAutoShutDown(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    const result = getCompletedAsyncWrapperObj(successData, error || "", errorContext);
    return of(
      checkAutoShutdownLoad(performance.now(), false),
      mainFunctionality(performance.now(), "checkAutoShutdown", false),
      loadedAutoShutDown(payload, result)
    );
  }
};
const loadAutoShutDownEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadAutoShutDownArgs);
const loadSrmMoorArgs = {
  filterOnType: loadSrmMoorTypes.LOAD,
  loadResource: (payload, state) => {
    return AlertingResource.loadAlerts(payload.workspaceid, payload.stepId);
  },
  loadingAction: (payload) => loadingSrmMoor(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    let placeHolder = { value: [], error: { code: "", message: "" } };
    successData = !!successData ? successData : placeHolder;
    const data = filterSRMEvidences(successData);
    const result = getCompletedAsyncWrapperObj(data, error || "", errorContext);
    return of(
      checkAlertsLoad(performance.now(), false),
      mainFunctionality(performance.now(), "checkAlerts", false),
      loadedSrmMoor(payload, result)
    );
  }
};
const loadSrmMoorEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadSrmMoorArgs);
const loadWarningDataArgs = {
  filterOnType: loadSrmAlertTypes.LOAD,
  loadResource: (payload, state) => {
    const scorecards = ___default.flatten(Object.values(payload.scorecardIds).map((d) => d || []));
    return SRMCheckResource.loadWarnings(payload.workspaceid, scorecards);
  },
  loadingAction: (payload) => loadingSrmAlert(payload),
  loadedAction: (successData, payload, error) => {
    const result = getCompletedAsyncWrapperObj(successData, error || "");
    return of(
      loadedSrmAlert(payload, result),
      checkWarningsLoad(performance.now(), false),
      mainFunctionality(performance.now(), "loadSrmAlert", false)
    );
  }
};
const loadWarningDataEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadWarningDataArgs);
const getRemainingWarmPerformance = (state, lastAction) => {
  const actions = [];
  !!state.gar.GARPerformance.stepPropertiesLoadTime && actions.push(checkStepPropertiesLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.planSummaryLoadTime && actions.push(checkPlanSummaryLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.autoShutdownLoadTime && actions.push(checkAutoShutdownLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.alertsLoadTime && actions.push(checkAlertsLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.analysesLoadTime && actions.push(checkAnalysesLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.scorecardsLoadTime && actions.push(checkScorecardsLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.hypothesisLoadTime && actions.push(checkHypothesisLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.slicesLoadTime && actions.push(checkSlicesLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.warningsLoadTime && actions.push(checkWarningsLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.metricCategoriesLoadTime && actions.push(checkMetricCategoriesLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.scorecardDataLoadTime && actions.push(checkScorecardDataLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, true));
  !!state.gar.GARPerformance.fullLoad && actions.push(mainFunctionality(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, lastAction, true));
  return actions;
};
const loadStudiesForStepEpicReducerInputArg = {
  actionPrefix: loadStudiesForStepActionPrefix,
  reduxKeyNested: (inputPayload) => [reduxNestedKeys.studiesForStep, inputPayload.stepId],
  loadResource: (inputPayload) => AnalysisResourceV2.getAnalyses(inputPayload.workspaceid, inputPayload.stepId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => getActionsAfterloadingStudies(inputPayload, outputPayload, state),
  dontLoad: (inputPayload, state) => {
    var _a;
    const { stepId } = inputPayload;
    const request = (_a = state.gar.GARModule.studiesForStep) == null ? void 0 : _a[stepId];
    return !!request && ((request == null ? void 0 : request.status) === AsyncRequestStatus.Pending || (request == null ? void 0 : request.status) === AsyncRequestStatus.Completed);
  }
};
const loadStudiesForStepEpicReducer = loadResourcesUtils(loadStudiesForStepEpicReducerInputArg);
const getActionsAfterloadingStudies = (inputPayload, outputPayload, state) => {
  var _a;
  const activeStudies = ((_a = outputPayload.value) == null ? void 0 : _a.filter(
    (data) => {
      var _a2, _b, _c;
      return data.state === AnalysisState.Active && data.analysisType !== AnalysisType.AAStream && ((_c = (_b = (_a2 = data.latestScorecardInfo) == null ? void 0 : _a2.scorecardLink) == null ? void 0 : _b.toLowerCase().includes(XCARD_DOMAIN)) != null ? _c : true);
    }
  )) || [];
  const filteredStudies = activeStudies.filter(
    (study) => study.analysisTemplate.metricSetVersion === null || study.analysisTemplate.metricSetVersion === void 0
  ) || [];
  const actions = [];
  state.gar.GARPerformance.analysesLoadTime == null && actions.push(checkAnalysesLoad(performance.now(), false));
  filteredStudies.forEach((data) => {
    var _a2, _b, _c, _d;
    const userDefinedFilter = getUserDefinedFilters(data.analysisFilters, data.analysisTemplate.name);
    const userDefinedFilterType = ((_a2 = userDefinedFilter == null ? void 0 : userDefinedFilter.operator) == null ? void 0 : _a2.toString()) || "";
    if (userDefinedFilterType !== GarConstants.TRAFFIC_FILTER_CONDITION_CUSTOM_WHERE) {
      actions.push(
        loadScorecardForStudies(
          {
            studyId: parseInt(data.id),
            studyName: data.name,
            isOneOff: ((_c = (_b = data.analysisTemplate) == null ? void 0 : _b.analysisTemplateOverrides) == null ? void 0 : _c.isOneOff) || false,
            flights: data.experimentMetadata.variants.map((variant) => {
              return { FlightName: variant.name, FlightType: variant.isControl ? "C" : "T" };
            }),
            userDefinedFilters: userDefinedFilter ? { [userDefinedFilter.name]: userDefinedFilter.values[0] } : void 0,
            userDefinedFilterType,
            primaryDataSource: ((_d = data.analysisTemplate) == null ? void 0 : _d.metricSetName) || "",
            markets: getMarketsFilterValues(data.analysisFilters)
          },
          inputPayload.workspaceid
        )
      );
    }
  });
  if (state.gar.GARPerformance.stepPropertiesLoadTime != null) {
    const warmActions = getRemainingWarmPerformance(state, "loadStudies");
    warmActions.forEach((a) => actions.push(a));
  } else {
    actions.push(checkStepPropertiesLoad(performance.now(), false));
  }
  state.gar.GARPerformance.fullLoad == null && actions.push(mainFunctionality(performance.now(), "loadStudies", false));
  return actions;
};
const loadScorecardsForStudiesEpic = (action$, state$) => {
  return action$.pipe(
    ofType(loadScorecardsForStudiesTypes.LOAD),
    mergeMap((data) => {
      const args = {
        payload: { payloadData: data.payload.payloadData, workspaceid: data.payload.workspaceid },
        loadResource: (payload, state) => {
          return AnalysisResourceV2.getScorecardRequests(payload.workspaceid, payload.payloadData.studyId);
        },
        state$,
        loadedAction: (successData, payload, error) => {
          const actions = [];
          const filteredResult = getScorecards((successData == null ? void 0 : successData.value) || [], payload.payloadData);
          const finalPayload = getCompletedAsyncWrapperObj(filteredResult, error || "");
          const scorecardsObj = Object.values(state$.value.gar.GARModule.scorecards).map((d) => d.data || []);
          const scorecards = ___default.flatten(scorecardsObj) || [];
          const allScorecards = scorecards.concat(filteredResult);
          const scorecardsStatus = Object.values(state$.value.gar.GARModule.scorecards).map(
            (data2) => data2.status
          );
          const filterS = scorecardsStatus.filter((status) => status === AsyncRequestStatus.Pending);
          if (filterS.length <= 1) {
            actions.push({
              type: "loadMetrics",
              payload: {
                workspaceid: payload.workspaceid,
                scorecards: allScorecards
              }
            });
          }
          filteredResult.map((res) => res.scorecardId).forEach((scorecard) => {
            actions.push(
              loadToCheckEmptyScEpicReducer.actionCreators.load({
                workspaceId: payload.workspaceid,
                scorecardId: scorecard
              })
            );
          });
          actions.push(
            loadedScorecardForStudies(
              {
                studyId: payload.payloadData.studyId,
                workspaceid: payload.workspaceid
              },
              finalPayload
            )
          );
          actions.push(
            checkScorecardsLoad(performance.now(), false),
            checkWarningsLoad(performance.now(), false),
            mainFunctionality(performance.now(), "checkScorecards", false)
          );
          return of(...actions);
        },
        loadingAction: (payload) => loadingScorecardForStudies({ studyId: payload.payloadData.studyId, workspaceid: payload.workspaceid })
      };
      return ReduxObservablesEpicUtils.innerLoadLoadingLoadedEpic(args);
    })
  );
};
const loadToCheckEmptyScEpicReducerInputArg = {
  actionPrefix: loadToCheckEmptyScPrefix,
  reduxKeyNested: (inputPayload) => [
    reduxNestedKeys.emptyScKey,
    inputPayload.scorecardId.toString()
  ],
  loadResource: (inputPayload) => GarXCardResource.loadToCheckEmptySc(inputPayload.workspaceId, inputPayload.scorecardId),
  onCompleteSuccess: (result) => {
    var _a, _b, _c;
    var count = 0;
    while (result.value[count] && result.value[count].segments.find((segment2) => segment2.level === 1 && segment2.value.toUpperCase() === "AGGREGATE") === void 0) {
      count++;
    }
    const segment = (_a = result.value[count]) == null ? void 0 : _a.segments.find(
      (segment2) => segment2.level === 1 && segment2.value.toUpperCase() === "AGGREGATE"
    );
    return {
      variant: result.variantCount === 0,
      segmentName: (_b = segment == null ? void 0 : segment.name) != null ? _b : "",
      segmentValue: (_c = segment == null ? void 0 : segment.value) != null ? _c : ""
    };
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const emptyScKeys = Object.keys(state.gar.GARModule.emptyScorecardResult).map(Number);
    const scToFinish = [];
    emptyScKeys.forEach((scID) => {
      if (state.gar.GARModule.emptyScorecardResult[scID].status == 0) {
        scToFinish.push(scID);
      }
    });
    if (scToFinish.length == 1 && scToFinish[0] == inputPayload.scorecardId) {
      return [
        checkSlicesLoad(performance.now(), false),
        mainFunctionality(performance.now(), "checkSlicesOrEmptyScorecard", false)
      ];
    }
    return [];
  }
};
const loadToCheckEmptyScEpicReducer = loadResourcesUtils(loadToCheckEmptyScEpicReducerInputArg);
const resolveQualityAlertsArg = {
  actionPrefix: resolveQualityAlertsPrefix,
  reduxKeyNested: (inputPayload) => [reduxNestedKeys.resolveAlertKey],
  loadResource: ({ alertEngageData, workspaceid }, state) => {
    const action = !!alertEngageData.alertEngagement ? alertEngageData.alertEngagement.action || "Resolve" : "Resolve";
    return GarXCardResource.resolveQualityAlerts(alertEngageData, action, workspaceid);
  },
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => [
    loadSrmMoor(inputPayload.workspaceid, inputPayload.stepId),
    resolveQualityAlertsEpicReducer.actionCreators.reset(inputPayload)
  ]
};
const resolveQualityAlertsEpicReducer = loadResourcesUtils(resolveQualityAlertsArg);
const loadSrmAlertEpicReducerInputArg = {
  actionPrefix: loadSrmAlertTypes.LOAD,
  reduxKeyNested: (inputPayload) => [reduxNestedKeys.warningsKey, inputPayload.scorecardId],
  loadResource: (inputPayload) => {
    return SRMCheckResource.loadWarningAsync(inputPayload.workspaceid, inputPayload.scorecardId);
  },
  onCompleteSuccess: (result, payload) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const srmAlertKeys = Object.keys(state.gar.GARModule.srmAlertResultMap).map(Number);
    const scToFinish = [];
    srmAlertKeys.forEach((scID) => {
      if (state.gar.GARModule.srmAlertResultMap[scID].status == 0) {
        scToFinish.push(scID);
      }
    });
    if (scToFinish.length == 1 && scToFinish[0] == Number(inputPayload.scorecardId)) {
      return [
        checkAlertsLoad(performance.now(), false),
        loadedSrmAsyncAlert(inputPayload, getCompletedAsyncWrapperObj(outputPayload)),
        mainFunctionality(performance.now(), "loadSrmAlert", false)
      ];
    }
    return [loadedSrmAsyncAlert(inputPayload, getCompletedAsyncWrapperObj(outputPayload))];
  }
};
const loadSrmAlertEpicReducer = loadResourcesUtils(loadSrmAlertEpicReducerInputArg);
const loadMetricsEpic = (action$, state$) => {
  return action$.pipe(
    ofType("loadMetrics"),
    mergeMap((value) => {
      const actions = [];
      const metricSets = getUniqueMetricSets(value.payload.scorecards);
      metricSets.forEach((metricSet) => {
        actions.push(
          loadMetricCategoriesEpic.actionCreators.load({
            metricSet,
            workspaceid: value.payload.workspaceid
          })
        );
      });
      actions.push(
        checkMetricCategoriesLoad(performance.now(), false),
        mainFunctionality(performance.now(), "loadMetricCategories", false)
      );
      return of(...actions);
    })
  );
};
const loadScorecardDataEpic = (action$, state$) => {
  return action$.pipe(
    ofType(loadScorecardDataTypes.LOAD),
    mergeMap((value) => {
      const allScorecards = ___default.flatten(
        Object.values(state$.value.gar.GARModule.scorecards).map((d) => d.data || [])
      );
      const scorecards = allScorecards.filter((sc) => sc.url.includes(value.payload.stepId));
      return getScorecardsData(
        {
          scorecards,
          control: value.payload.control,
          treatment: value.payload.treatment,
          workspaceid: value.payload.workspaceid,
          stepId: value.payload.stepId
        },
        state$
      );
    })
  );
};
const getScorecardsData = (inputPayload, state$) => {
  const scorecardsWithDataLoaded = [];
  return from(inputPayload.scorecards).pipe(
    mergeMap((scorecard, index) => {
      const args = {
        payload: {
          scorecard,
          control: inputPayload.control,
          treatment: inputPayload.treatment,
          workspaceid: inputPayload.workspaceid,
          stepId: inputPayload.stepId
        },
        loadResource: (payload, state) => {
          var _a, _b, _c, _d, _e, _f;
          const metricCategories = (state == null ? void 0 : state.gar.GARModule.metricCategories) || {};
          const metrics = ((_b = (_a = metricCategories[payload.scorecard.primaryDataSource]) == null ? void 0 : _a.data) == null ? void 0 : _b.metricCategoryMappings.map(
            (metricCategory) => metricCategory.metricName
          )) || [];
          const segmentName = (_d = (_c = state == null ? void 0 : state.gar.GARModule.emptyScorecardResult[scorecard.scorecardId]) == null ? void 0 : _c.data) == null ? void 0 : _d.segmentName;
          const segmentValue = (_f = (_e = state == null ? void 0 : state.gar.GARModule.emptyScorecardResult[scorecard.scorecardId]) == null ? void 0 : _e.data) == null ? void 0 : _f.segmentValue;
          return GarXCardResource.getScorecardData(
            scorecard.scorecardId,
            metrics,
            scorecard.startDate,
            scorecard.endDate,
            payload.control,
            payload.treatment,
            payload.workspaceid,
            segmentName != null ? segmentName : "",
            segmentValue != null ? segmentValue : "",
            scorecard.triggerFilterFlag,
            scorecard.triggerFilterCondition
          );
        },
        state$,
        loadedAction: (successData, payload, error) => {
          var _a, _b, _c;
          const data = state$.value.gar.GARModule.metricCategories;
          const metricCategoryMappings = ((_b = (_a = data[payload.scorecard.primaryDataSource]) == null ? void 0 : _a.data) == null ? void 0 : _b.metricCategoryMappings) || [];
          const mappedMetrics = getMappedMetrics(
            successData,
            metricCategoryMappings,
            (_c = state$.value.gar.GARModule.hypothesisResult.data) == null ? void 0 : _c.value.targetMetrics
          );
          const result = getCompletedAsyncWrapperObj(mappedMetrics, error || "");
          scorecardsWithDataLoaded.push(scorecard.scorecardId);
          if (scorecardsWithDataLoaded.length == inputPayload.scorecards.length) {
            const actions = [];
            actions.push(loadedScorecardData(payload, result));
            if (state$.value.gar.GARPerformance.scorecardDataLoadTime != null) {
              const warmActions = getRemainingWarmPerformance(state$.value, "scorecardDataLoad");
              warmActions.forEach((a) => actions.push(a));
            } else {
              actions.push(checkScorecardDataLoad(performance.now(), false));
            }
            state$.value.gar.GARPerformance.fullLoad == null && actions.push(mainFunctionality(performance.now(), "scorecardDataLoad", false));
            return of(...actions);
          }
          return of(loadedScorecardData(payload, result));
        },
        loadingAction: (payload) => loadingScorecardData(payload),
        dontLoad: (payload, state) => {
          const scorecardData = state && state.gar.GARModule.scorecardData && state.gar.GARModule.scorecardData[`${payload.control}:${payload.treatment}:${payload.scorecard.scorecardId}`] && state.gar.GARModule.scorecardData[`${payload.control}:${payload.treatment}:${payload.scorecard.scorecardId}`].status !== AsyncRequestStatus.Failed;
          return !!scorecardData;
        }
      };
      return ReduxObservablesEpicUtils.innerLoadLoadingLoadedEpic(args);
    })
  );
};
const loadMetricCategoriesArgs = {
  actionPrefix: loadMetricCategoriesPrefix,
  reduxKeyNested: (inputPayload) => ["metricCategories", inputPayload.metricSet],
  loadResource: (payload, state) => {
    return GarVivaceResource.getMetricCategories(payload.metricSet, payload.workspaceid);
  },
  onCompleteSuccess: (result) => getFilteredMetricCategories(result),
  onLoaded: (response, payload, state) => {
    if (!!response && response.statusCode == 404) {
      const emptyResult = {
        metricSet: payload.metricSet,
        workspace: payload.workspaceid,
        metricCategoryMappings: []
      };
      return {
        isSuccessful: true,
        data: emptyResult
      };
    }
    return void 0;
  }
};
const loadMetricCategoriesEpic = loadResourcesUtils(loadMetricCategoriesArgs);
const loadExperimentPlanIdArgs = {
  filterOnType: loadExperimentPlanIdTypes.LOAD,
  loadResource: (payload, state) => {
    return GarExpApiResource.getExperimentPlanId(payload.stepId);
  },
  loadingAction: (payload) => loadingExperimentPlanId(payload),
  loadedAction: (successData, payload, error) => {
    const actions = [];
    if (!!successData) {
      actions.push(loadExperimentInfo(successData.ExperimentPlanId));
    }
    return of(...actions);
  }
};
const loadExperimentPlanIdEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadExperimentPlanIdArgs);
const loadHypothesisEpicReducerInputArg = {
  actionPrefix: loadHypothesisActionPrefix,
  reduxKeyNested: () => [reduxNestedKeys.hypothesisKey],
  loadResource: (inputPayload) => {
    return AnalysisResourceV2.getHypothesis(inputPayload.workspaceId, inputPayload.featureId);
  },
  onCompleteSuccess: (result, input) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    return [
      checkHypothesisLoad(performance.now(), false),
      mainFunctionality(performance.now(), "loadHypothesis", false)
    ];
  }
};
const loadHypothesisEpicReducer = loadResourcesUtils(loadHypothesisEpicReducerInputArg);
const loadExperimentInfoArgs = {
  filterOnType: loadExperimentInfoTypes.LOAD,
  loadResource: (payload, state) => {
    return GarExpApiResource.getExperimentInfo(payload.planId);
  },
  loadingAction: (payload) => loadingExperimentInfo(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    const actions = [];
    const result = getCompletedAsyncWrapperObj(successData, error || "", errorContext);
    actions.push(loadedExperimentInfo(payload, result));
    if (!!successData && successData.FeatureRolloutMetadata) {
      actions.push(
        loadHypothesisEpicReducer.actionCreators.load({
          workspaceId: successData.WorkspaceId,
          featureId: successData.FeatureRolloutMetadata.RootExperimentId
        })
      );
    } else {
      actions.push(checkHypothesisLoad(GarLogPerformanceConstants.NO_LOAD_PLACEHOLDER, false));
    }
    actions.push(
      checkExperimentInfoLoad(performance.now(), false),
      mainFunctionality(performance.now(), "checkExperimentInfo", false)
    );
    return of(...actions);
  }
};
const loadExperimentInfoEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadExperimentInfoArgs);
const loadPlanSummaryEpicReducerInputArg = {
  actionPrefix: loadPlanSummaryActionPrefix,
  reduxKeyNested: () => [reduxNestedKeys.planSummaryKey],
  loadResource: (inputPayload) => GarExpApiResource.getPlanSummary(inputPayload.stepId),
  onCompleteSuccess: (result, input) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    return [
      checkPlanSummaryLoad(performance.now(), false),
      mainFunctionality(performance.now(), "planSummary", false),
      loadExperimentInfo(outputPayload.Id)
    ];
  }
};
const loadPlanSummaryEpicReducer = loadResourcesUtils(loadPlanSummaryEpicReducerInputArg);
const loadScorecardInsightsEpicReducerInputArg = {
  actionPrefix: loadScorecardInsightsPrefix,
  reduxKeyNested: (inputPayload) => [reduxNestedKeys.soiKey, inputPayload.ScorecardId.toString()],
  loadResource: (inputPayload) => {
    return GarScorecardResource.getScorecardInsights(inputPayload);
  },
  onCompleteSuccess: (result, input) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    return [
      checkScorecardInsightsLoad(performance.now(), false),
      mainFunctionality(performance.now(), "scorecardInsights", false)
    ];
  },
  dontLoad: (payload, state) => {
    const scorecardInsights = state && state.gar.GARModule.scorecardInsightsResult && state.gar.GARModule.scorecardInsightsResult[`${payload.ScorecardId}`] && state.gar.GARModule.scorecardInsightsResult[`${payload.ScorecardId}`].status !== AsyncRequestStatus.Failed;
    return !!scorecardInsights;
  }
};
const loadScorecardInsightsEpicReducer = loadResourcesUtils(loadScorecardInsightsEpicReducerInputArg);
const provideGAREpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    GARContextParams,
    setUserContext,
    GarConstants.SET_PARTIAL_USER_CONTEXT,
    GarConstants.SET_USER_CONTEXT,
    (store) => store.gar.GARModule.garContext,
    history,
    (pathname) => {
      const match = matchPath(pathname, {
        path: ROUTES.gar.root.match.path
      });
      return !!pathname && !pathname.includes(`${ROUTES.analysis.scorecardTask.location.pathname}`) && /**
      * prevent URL sync from removing query params on analysis GAR create and clone routes
      */
      !(matchesRootPathname(pathname, GarRouteUtils.routes.create.path()) || matchesRootPathname(pathname, GarRouteUtils.routes.clone.path())) && ((match == null ? void 0 : match.path) === ROUTES.gar.root.match.path || (match == null ? void 0 : match.path) === ROUTES.gar.view.match.path);
    },
    EXP_QUERY_STRINGS
  );
  return combineEpics(
    loadAutoShutDownEpic,
    loadSrmMoorEpic,
    loadWarningDataEpic,
    loadSrmAlertEpicReducer.epic,
    loadScorecardDataEpic,
    loadMetricCategoriesEpic.epic,
    loadExperimentPlanIdEpic,
    loadExperimentInfoEpic,
    loadScorecardsForStudiesEpic,
    loadMetricsEpic,
    loadPlanSummaryEpicReducer.epic,
    loadHypothesisEpicReducer.epic,
    loadStudiesForStepEpicReducer.epic,
    loadToCheckEmptyScEpicReducer.epic,
    loadScorecardInsightsEpicReducer.epic,
    resolveQualityAlertsEpicReducer.epic,
    ...Object.values(setUserContextFromRouteQueryString)
  );
};
export {
  getActionsAfterloadingStudies,
  getRemainingWarmPerformance,
  getScorecardsData,
  loadAutoShutDownEpic,
  loadExperimentInfoEpic,
  loadExperimentPlanIdEpic,
  loadHypothesisEpicReducer,
  loadMetricCategoriesEpic,
  loadMetricsEpic,
  loadPlanSummaryEpicReducer,
  loadScorecardDataEpic,
  loadScorecardInsightsEpicReducer,
  loadScorecardsForStudiesEpic,
  loadSrmAlertEpicReducer,
  loadSrmMoorEpic,
  loadStudiesForStepEpicReducer,
  loadToCheckEmptyScEpicReducer,
  loadWarningDataEpic,
  provideGAREpics,
  resolveQualityAlertsEpicReducer
};
//# sourceMappingURL=GarEpic.js.map
